export class ActivacionCargueFiviI{
  id: BigInteger;
  idFte: BigInteger;
  idPeriodo: BigInteger;
  idEstinf: BigInteger;
  fecha: String;
  tipo: String;
  usuario: String;
  observacion: String;
  errorVD: Boolean;
  errorNC: Boolean;
}
